import { RecordOf } from '@opengov/compose-app/immutable';
import { IReportConfiguration } from '@opengov/reporting-types';

export interface ISummaryTable {
  data: any[];
  columns: any[];
  reportConfiguration: IReportConfiguration;
}

export const SummaryTableRecord = RecordOf<ISummaryTable>({
  data: undefined,
  columns: undefined,
  reportConfiguration: undefined
});
